import { handleActions } from "redux-actions";
import { api } from "api";
import { NotificationManager } from "react-notifications";
import { listarVendedores, reporteVentaDeVehiculos } from "./ventas";
import Swal from 'sweetalert2';

const PARAMETRO = 'PARAMETRO';
const POLIZA = 'POLIZA';
const LOADER = 'LOADER';
const DIFERENCIA = 'DIFERENCIA';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const datosDeVenta = (ventaId, datos) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    let action = "editar";
    const params = { id, action };
    dispatch(setLoader(true));
    return api
        .get(`auto_ventas/ventas/${ventaId}`, params)
        .then((response) => {
            if (datos.contabilidad === 'S'){
                if (response.poliza[0].encabezado){
                    dispatch(leerDetalleMod(response.poliza[0].encabezado));
                }else{
                    dispatch(leerDetalleMod('00000000-0000-0000-0000-000000000000'));
                }
            }
            return response;
        })
        .catch((error) => {
            NotificationManager.error(
                "Ocurrio un error al obtener los datos",
                "Error",
                2000,
                null,
                true
            );
            return [];
        }).finally(() => {
            dispatch(setLoader(false));
        });
};

export const editarVenta = (data, ventaId) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    if (data.datos.contabilidad === 'S'){
        const totalDebe = data.poliza.reduce((sum, linea) => sum + parseFloat(linea.debe), 0);
        const totalHaber = data.poliza.reduce((sum, linea) => sum + parseFloat(linea.haber), 0);
        if (data.poliza.length === 0) {
            Swal.fire({
                title: 'Ventas',
                text: 'Debe agregar líneas a la póliza',
                type: 'error',
            });
            return;
        }else if (Math.abs(totalDebe - totalHaber) >= 0.01) {
            Swal.fire({
                title: 'Ventas',
                text: 'Póliza con diferencia',
                type: 'error',
            });
            return;
        }else{
            data.empresa = id;
            data.vendedor = data.vendedor.value;
            const params = { id, ...data };
            return api
                .put(`auto_ventas/ventas/${ventaId}`, params)
                .then(() => {
                    NotificationManager.success(
                        "Venta editada",
                        "Exito",
                        3000,
                        null,
                        true
                    );
                    return true;
                })
                .catch((error) => {
                    NotificationManager.error(error.msj, "Error", 2000, null, true);
                    return false;
                });
        }
    }else{
        data.empresa = id;
        data.vendedor = data.vendedor.value;
        const params = { id, ...data };
        return api
            .put(`auto_ventas/ventas/${ventaId}`, params)
            .then(() => {
                NotificationManager.success(
                    "Venta editada",
                    "Exito",
                    3000,
                    null,
                    true
                );
                return true;
            })
            .catch((error) => {
                NotificationManager.error(error.msj, "Error", 2000, null, true);
                return false;
            });
    }
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    })
}

const eliminarLinea = (id, idPoliza) => (dispatch) => {
    Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Está seguro que desea eliminar esta línea de la póliza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.value) {
            api.eliminar(`poliza_detalle/${id}`).then(() => {
                const editar = window.location.href.includes('editar');
                if (editar) {
                    dispatch(leerDetalleMod(idPoliza));
                    Swal.fire({
                        title: 'Eliminado',
                        text: 'La línea ha sido eliminada correctamente',
                        type: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });
                }
            }).catch(() => {
                NotificationManager.error(
                    'Ocurrió un error en eliminar linea de poliza',
                    'Error',
                    3000
                );
            })
        }
    });
};

const leerDetalleMod = id => (dispatch) => {
    api.get(`/poliza_detalle/${id}`).then((response) => {
        response.polizaDetalle_polizaEncabezado = response
        let polizaD = response.polizaDetalle_polizaEncabezado = response
        dispatch({ type: POLIZA, poliza: response });
        // Calcular totales
        let totalDebe = polizaD.reduce((sum, linea) => sum + parseFloat(linea.debe), 0);
        let totalHaber = polizaD.reduce((sum, linea) => sum + parseFloat(linea.haber), 0);
        let diferenciaTotal = totalDebe - totalHaber;
        dispatch({ type: DIFERENCIA, diferencia: diferenciaTotal });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            3000
        );
    })
};

export const listarCuentas = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/cuentas/empresa_cuentas/',params).then(data=>{
        const list_cuentas = [];
        if(data){
            data.forEach(item=>{
                if (item.tipo === 'A'){
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre,
                        isDisabled: true
                    })
                }else{
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre
                    })
                }
            })
        }
        return list_cuentas;
    }).catch(()=>{
        return [];
    })
}

export const registroPolizaDetalle = (data) => (dispatch) => {
    let idPoliza = data.idPoliza
    const formData = {
        cc: 0,
        cuenta: data.cuenta_id,
        debe: data.debe,
        haber: data.haber,
        poliza: idPoliza
    }
    
    dispatch(setLoader(true));
    api.post('/polizas/encabezado_polizas/', formData).then(() => {
        const editar = window.location.href.includes('editar');
        if (editar) {
            dispatch(leerDetalleMod(idPoliza));
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al registrar la poliza',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const actions = {
    datosDeVenta,
    listarVendedores,
    reporteVentaDeVehiculos,
    editarVenta,
    parametrosEmpresa,
    eliminarLinea,
    listarCuentas,
    registroPolizaDetalle
};

export const reducers = {
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [POLIZA]: (state, { poliza }) => {
        return {
            ...state,
            poliza,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DIFERENCIA]: (state, { diferencia }) => {
        return {
            ...state,
            diferencia,
        };
    },
};

export const initialState = {
    datos: [],
    poliza: [],
    loader: false,
    diferencia: 0.00
};

export default handleActions(reducers, initialState);
